export enum EventsEnum {
  Loaded = 'Loaded',
  DocumentRequestedViaSMS = 'DocumentRequestedViaSMS',
  PartnerLoaded = 'PartnerLoaded',
  ActionWebhookUrlInitialize = 'ActionWebhookUrlInit',
}
